import template from './ticketAssetFinance.template.html';

export default {
  template,
  bindings: {
    formName: '<',
    assetFinance: '<',
    lenders: '<',
    isTicketSettled: '<',
    onFinished: '&'
  },
  controller: class controller {
    constructor($rootScope, $mdMedia, helperService) {
      'ngInject';
      /*
       * Controller model
       * --------------------------------------------------------------------------------
       */
      const ctrl = this;
      ctrl.mdMedia = $mdMedia;
      ctrl.currentCurrency = null;
      ctrl.availableAssetFinanceAssetAges = [];
      ctrl.isReady = false;

      /*
       * Methods
       * --------------------------------------------------------------------------------
       */
      ctrl.initialize = () => {
        ctrl.currentCurrency = $rootScope.CurrentCurrency();
        ctrl.availableAssetFinanceAssetAges = helperService.getAvailableAssetFinanceAssetAges({
          showAll: true
        });
        ctrl.assetFinance = ctrl.assetFinance || {};
        ctrl.lenders = ctrl.lenders || [];
        ctrl.isTicketSettled = ctrl.isTicketSettled || false;
        ctrl.isReady = true;
      };

      ctrl.clearSearchTerm = () => {
        ctrl.searchTerm = '';
      };

      ctrl.isLenderSelected = (lender) => {
        if (lender && ctrl.lenders.length) {
          const lS = ctrl.lenders.find((l) => l.abbr.toLowerCase() === lender);
          return lS !== undefined;
        }
        return true;
      };

      /*
       * Save asset finance
       * --------------------------------------------------------------------------------
       */
      ctrl.saveTicketAssetFinance = () => ctrl.onFinished({ assetFinance: ctrl.assetFinance });

      /*
       * Execute when all bindings are completed
       * --------------------------------------------------------------------------------
       */
      ctrl.$onInit = function () {
        ctrl.initialize();
      };
    }
  }
};
